import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import WithI18next from "../components/WithI18next";

const PageTemplate = ({ data }) => {
  return (
    <Layout
      title={data.wpPage.seo.title}
      description={data.wpPage.seo.metaDesc}
    >
      <div className="pt-5">
        <div id={data.wpPage.slug} className="container py-5 page-content">
          <h1
            className="mb-3"
            dangerouslySetInnerHTML={{ __html: data.wpPage.title }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: `<div> ${data.wpPage.content} </div>`,
            }}
          />
        </div>
      </div>
    </Layout>
  );
};

export default WithI18next()(PageTemplate);

export const query = graphql`
  query ($id: Int!, $wpLocale: String!, $wpGlobalConfig: String!) {
    wpPage(
      databaseId: { eq: $id }
      language: { locale: { eq: $wpLocale } }
      acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
    ) {
      title
      content
      slug
      seo {
        canonical
        # focuskw
        metaDesc
        # metaKeywords
        # metaRobotsNofollow
        # metaRobotsNoindex
        # opengraphAuthor
        # opengraphDescription
        # opengraphModifiedTime
        # opengraphPublishedTime
        # opengraphPublisher
        # opengraphSiteName
        # opengraphTitle
        # opengraphType
        # opengraphUrl
        title
        # twitterDescription
        # twitterTitle
      }
    }
  }
`;
